export const PATH_QUALITY = 0.5;
export const ANGLE_TOLERANCE = 90;

export const STAR_BREATHING_VO = {
  intro: ['NFC_2.0_28'],
  elmo_up: ['NFC_2.0_28_01'],
  elmo_down: ['NFC_2.0_28_02'],
  breathe_in: ['NFC_2.0_29'],
  breathe_out: ['NFC_2.0_30'],
  user_start: ['NFC_2.0_40'],
  user_timeout_options: ['NFC_2.0_37_ALT', 'NFC_2.0_38_ALT'],
  copy_start: ['NFC_2.0_42'],
  complete: ['NFC_6.0_96'],
};

export const HANDS = {
  elmo: {
    image: { sheet: 'star_breathing', key: 'hand_elmo' },
    path: [
      { x: -204, y: -152, star: true },
      { x: -219, y: -169 },
      { x: -230, y: -184 },
      { x: -244, y: -200 },
      { x: -257, y: -215 },
      { x: -270, y: -231 },
      { x: -287, y: -241 },
      { x: -303, y: -253 },
      { x: -320, y: -266 },
      { x: -334, y: -278 },
      { x: -348, y: -292 },
      { x: -361, y: -309 },
      { x: -373, y: -326 },
      { x: -383, y: -343 },
      { x: -389, y: -362 },
      { x: -391, y: -381 },
      { x: -388, y: -403 },
      { x: -382, y: -423 },
      { x: -372, y: -440, star: true },
      { x: -361, y: -455 },
      { x: -344, y: -468 },
      { x: -326, y: -476 },
      { x: -306, y: -478 },
      { x: -286, y: -476 },
      { x: -266, y: -474 },
      { x: -246, y: -468 },
      { x: -228, y: -460 },
      { x: -216, y: -453, star: true },
      { x: -223, y: -466 },
      { x: -230, y: -486 },
      { x: -236, y: -505 },
      { x: -242, y: -524 },
      { x: -246, y: -542 },
      { x: -250, y: -563 },
      { x: -253, y: -583 },
      { x: -257, y: -604 },
      { x: -259, y: -623 },
      { x: -257, y: -643 },
      { x: -255, y: -663 },
      { x: -249, y: -683 },
      { x: -238, y: -700 },
      { x: -224, y: -715 },
      { x: -208, y: -727, star: true },
      { x: -189, y: -736 },
      { x: -172, y: -743 },
      { x: -150, y: -748 },
      { x: -132, y: -748 },
      { x: -113, y: -740 },
      { x: -96, y: -730 },
      { x: -82, y: -713 },
      { x: -73, y: -695 },
      { x: -67, y: -676 },
      { x: -61, y: -658 },
      { x: -57, y: -637 },
      { x: -53, y: -617 },
      { x: -50, y: -597 },
      { x: -47, y: -578 },
      { x: -45, y: -558 },
      { x: -45, y: -545, star: true },
      { x: -39, y: -559 },
      { x: -34, y: -578 },
      { x: -27, y: -597 },
      { x: -19, y: -618 },
      { x: -10, y: -636 },
      { x: -1, y: -655 },
      { x: 8, y: -673 },
      { x: 21, y: -689 },
      { x: 34, y: -703 },
      { x: 50, y: -716 },
      { x: 67, y: -726 },
      { x: 86, y: -730 },
      { x: 105, y: -730 },
      { x: 126, y: -725 },
      { x: 145, y: -720, star: true },
      { x: 163, y: -709 },
      { x: 179, y: -698 },
      { x: 191, y: -682 },
      { x: 202, y: -664 },
      { x: 207, y: -644 },
      { x: 209, y: -625 },
      { x: 209, y: -603 },
      { x: 207, y: -584 },
      { x: 202, y: -564 },
      { x: 196, y: -546 },
      { x: 190, y: -528 },
      { x: 181, y: -505, star: true },
      { x: 194, y: -514 },
      { x: 210, y: -526 },
      { x: 227, y: -537 },
      { x: 245, y: -546 },
      { x: 265, y: -550 },
      { x: 285, y: -555 },
      { x: 306, y: -550 },
      { x: 324, y: -542 },
      { x: 341, y: -532 },
      { x: 358, y: -519 },
      { x: 370, y: -505, star: true },
      { x: 381, y: -486 },
      { x: 387, y: -466 },
      { x: 390, y: -447 },
      { x: 385, y: -428 },
      { x: 378, y: -408 },
      { x: 367, y: -392 },
      { x: 354, y: -375 },
      { x: 341, y: -361 },
      { x: 330, y: -345 },
      { x: 315, y: -330 },
      { x: 302, y: -315 },
      { x: 289, y: -301 },
      { x: 276, y: -285 },
      { x: 263, y: -269 },
      { x: 250, y: -252 },
      { x: 236, y: -239 },
      { x: 224, y: -223 },
      { x: 211, y: -208 },
      { x: 197, y: -192 },
      { x: 184, y: -176 },
      { x: 170, y: -162 },
      { x: 157, y: -147 },
      { x: 144, y: -132, star: true },
    ],
  },
  human: {
    image: { sheet: 'star_breathing', key: 'hand_human' },
    path: [
      { x: -186, y: -88, star: true },
      { x: -192, y: -107 },
      { x: -208, y: -120 },
      { x: -224, y: -133 },
      { x: -237, y: -148 },
      { x: -248, y: -163 },
      { x: -259, y: -182 },
      { x: -268, y: -199 },
      { x: -278, y: -217 },
      { x: -286, y: -237 },
      { x: -294, y: -254 },
      { x: -301, y: -273 },
      { x: -309, y: -291 },
      { x: -316, y: -310 },
      { x: -328, y: -328 },
      { x: -343, y: -340 },
      { x: -356, y: -354 },
      { x: -367, y: -371 },
      { x: -377, y: -389 },
      { x: -383, y: -408 },
      { x: -382, y: -428 },
      { x: -375, y: -447 },
      { x: -362, y: -462, star: true },
      { x: -345, y: -472 },
      { x: -326, y: -476 },
      { x: -305, y: -475 },
      { x: -285, y: -470 },
      { x: -268, y: -462 },
      { x: -250, y: -449 },
      { x: -236, y: -436 },
      { x: -222, y: -421 },
      { x: -209, y: -405 },
      { x: -197, y: -390 },
      { x: -187, y: -371, star: true },
      { x: -176, y: -389 },
      { x: -165, y: -406 },
      { x: -156, y: -425 },
      { x: -149, y: -445 },
      { x: -146, y: -465 },
      { x: -142, y: -485 },
      { x: -141, y: -504 },
      { x: -140, y: -525 },
      { x: -139, y: -546 },
      { x: -137, y: -567 },
      { x: -137, y: -587 },
      { x: -136, y: -608 },
      { x: -135, y: -628 },
      { x: -133, y: -649 },
      { x: -129, y: -669 },
      { x: -123, y: -689 },
      { x: -111, y: -705 },
      { x: -98, y: -721 },
      { x: -81, y: -730 },
      { x: -59, y: -734, star: true },
      { x: -40, y: -733 },
      { x: -22, y: -722 },
      { x: -8, y: -708 },
      { x: 0, y: -689 },
      { x: 5, y: -668 },
      { x: 8, y: -649 },
      { x: 8, y: -628 },
      { x: 7, y: -607 },
      { x: 7, y: -588 },
      { x: 5, y: -567 },
      { x: 3, y: -546 },
      { x: -1, y: -507, star: true },
      { x: 2, y: -527 },
      { x: 5, y: -528 },
      { x: 10, y: -546 },
      { x: 12, y: -565 },
      { x: 19, y: -586 },
      { x: 26, y: -604 },
      { x: 34, y: -623 },
      { x: 43, y: -642 },
      { x: 50, y: -659 },
      { x: 61, y: -678 },
      { x: 71, y: -695 },
      { x: 86, y: -708 },
      { x: 105, y: -718 },
      { x: 123, y: -723 },
      { x: 144, y: -720, star: true },
      { x: 163, y: -711 },
      { x: 177, y: -697 },
      { x: 185, y: -678 },
      { x: 189, y: -659 },
      { x: 186, y: -637 },
      { x: 180, y: -618 },
      { x: 175, y: -600 },
      { x: 166, y: -581 },
      { x: 158, y: -561 },
      { x: 148, y: -543 },
      { x: 140, y: -524 },
      { x: 134, y: -506 },
      { x: 123, y: -487 },
      { x: 114, y: -469, star: true },
      { x: 125, y: -486 },
      { x: 138, y: -506 },
      { x: 147, y: -525 },
      { x: 157, y: -541 },
      { x: 168, y: -559 },
      { x: 181, y: -575 },
      { x: 192, y: -590 },
      { x: 207, y: -604 },
      { x: 223, y: -616 },
      { x: 244, y: -623 },
      { x: 264, y: -624 },
      { x: 285, y: -616, star: true },
      { x: 300, y: -600 },
      { x: 310, y: -583 },
      { x: 313, y: -563 },
      { x: 310, y: -542 },
      { x: 303, y: -521 },
      { x: 295, y: -506 },
      { x: 283, y: -486 },
      { x: 271, y: -471 },
      { x: 262, y: -454 },
      { x: 248, y: -437 },
      { x: 236, y: -421 },
      { x: 222, y: -404 },
      { x: 208, y: -388, star: true },
      { x: 223, y: -405 },
      { x: 236, y: -418 },
      { x: 253, y: -431 },
      { x: 267, y: -443 },
      { x: 283, y: -455 },
      { x: 302, y: -464 },
      { x: 320, y: -470 },
      { x: 341, y: -468 },
      { x: 359, y: -461 },
      { x: 374, y: -446, star: true },
      { x: 381, y: -427 },
      { x: 383, y: -409 },
      { x: 379, y: -388 },
      { x: 372, y: -370 },
      { x: 359, y: -353 },
      { x: 345, y: -340 },
      { x: 328, y: -326 },
      { x: 314, y: -312 },
      { x: 298, y: -302 },
      { x: 282, y: -289 },
      { x: 267, y: -274 },
      { x: 252, y: -261 },
      { x: 236, y: -249 },
      { x: 222, y: -237 },
      { x: 213, y: -219 },
      { x: 205, y: -199 },
      { x: 193, y: -181 },
      { x: 183, y: -164 },
      { x: 172, y: -149 },
      { x: 159, y: -134 },
      { x: 147, y: -117 },
      { x: 136, y: -102 },
      { x: 129, y: -84, star: true },
    ],
  },
};

export const PATH_TEST = [];
